<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Web Development</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Web Development</li>
            </ul>
        </div>
    </div>
</div>

<section class="space">
    <div class="container">
        <div class="row">
            <div class="col-xxl-8 col-lg-7">
                <div class="page-single">
                    <div class="service-img sv-details-img">
                        <img class="w-100" src="assets/img/service/development.png.webp" alt="Web Development" />
                    </div>
                    <div class="page-content sv-content d-block">
                        <h2 class="box-title">Web Development</h2>
                        <p class="box-text mb-30">Xipe Tech is a leading Web Development Company in India delivering
                            high quality web solutions around world for years. We provide the best-in-class website
                            development services in Lucknow by developing a dynamic and powerful websites.
                        </p>
                        <div class="sv-gallery-wrapper">
                            <div class="row gy-4">
                                <div class="col-6">
                                    <div class="sv-sm-img">
                                        <img class="w-100" src="assets/img/service/video-image-1.jpg.webp" alt="" />
                                    </div>
                                </div>
                                <div class="col-6 my-5">
                                    <h2 class="box-title">Why Web Development Important?</h2>
                                    <p>Here's what sets our website development services apart:</p>
                                    <div class="checklist tick-checklist sv-details-list mb-40">
                                        <ul>
                                            <li>Customized Solutions</li>
                                            <li>User-Centric Design</li>
                                            <li>Cutting-Edge Technologies</li>
                                            <li>Search Engine Optimization (SEO)</li>
                                            <li>Integration and Functionality</li>
                                            <li>Ongoing Support and Maintenance</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row gy-4">
                                <div class="col-12">
                                    <p>By choosing Xipetech for website development, businesses can expect a
                                        collaborative approach, innovative design, and robust functionality. We are
                                        committed to delivering websites that not only leave a lasting impression but
                                        also drive business growth and success in the digital world.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-4 col-lg-5">
                <app-service-sidebar></app-service-sidebar>
            </div>
        </div>
    </div>
</section>

<!--======== Footer Section ========-->
<app-footer></app-footer>